import _merge from 'lodash/merge'
import { useState } from 'react'
import { btoa, requiredCheck } from '@ztechapps/common.utils'
import { useDeepCompareEffect } from '@ztechapps/common.hook'

export type UsePivotProps = {
  url: string
  query: {
    name: string
    filter: Record<any, any>
  } & Record<any, any>
  accessToken: string
}
export const usePivot = ({ url, query, accessToken }: UsePivotProps) => {
  const [pivotUrl, setPivotUrl] = useState(null)

  const _getUrl = ({ url, query, timeStamp = undefined }) => {
    requiredCheck(accessToken, 'is required when previewing report')
    requiredCheck(url, 'url is required when previewing report')

    const paramsBtoa = btoa({ accessToken, ...query, timeStamp })
    const _url = `${url}/${paramsBtoa}`
    setPivotUrl(_url)
  }

  const refreshUrl = (options = {}) => {
    const timeStamp = new Date().getTime()
    const mergeArgs = _merge({ url, query, timeStamp }, options)
    _getUrl(mergeArgs)
  }

  useDeepCompareEffect(() => {
    _getUrl({ url, query })
  }, [query])

  return { refreshUrl, pivotUrl }
}
